<template>
  <v-card @click="keepFocus()" style="background-color: #f2f2f2">
    <div class="invitation__new" style="padding: 20px;">
      <div class="invitation__new--title" style="margin-bottom: 15px;">
        <p class="invitation__new_text--title" style="font-size: 18px; font-weight: bold;">
          Crear Invitación
        </p>
      </div>

      <div class="invitation__new--info_container">
        <v-text-field v-model="new_invitation.identification_data" ref="identificationData" name="identification_data"
          style="position: absolute; width: 0; height: 0; opacity: 0; border: none; padding: 0;"
          @keyup.enter="fillFields">
        </v-text-field>

        <div style="display: flex; justify-content: space-between; align-items: stretch; gap: 20px; height: 58vb;">
          <div class="table_card" style="flex: 1">
            <div class="table_card__head" style="height: 3.5vb; background-color: #4473C3; display: flex; padding: 0;">
              <p class="table_card__head--title"
                style="color: #f0f0f0; font-weight: 400; margin: 0 0 0 3%; line-height: 1;">
                Datos Personales
              </p>
            </div>


            <div class="table_card__body">
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div style="flex: 1; margin-right: 20px;">

                  <!-- Checkbox para habilitar entrada manual -->
                  <v-radio-group v-model="fieldEnabled" :mandatory="true" class="input-group"
                    style="display: flex; justify-content: center; align-items: center; width: 100%;">
                    <div style="display: flex; gap: 20px;">
                      <v-radio color="blue" label="Escáner" :value="false" class="input-group__radio"></v-radio>
                      <v-radio color="blue" label="Manual" :value="true" class="input-group__radio"></v-radio>
                    </div>
                  </v-radio-group>

                  <!-- Inputs con errores ajustados -->
                  <div style="margin-bottom: 16px;"> <!-- Separación normal entre inputs -->
                    <input id="rut" type="text" v-model="new_invitation.rut" name="rut" v-validate="'required'"
                      :readonly="!fieldEnabled" class="input-group" placeholder="Número de cédula"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                    <p v-show="errors.has('rut')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Ingresa un número de cédula válido
                    </p>
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input id="name" type="text" v-model="new_invitation.name" v-validate="'required|alpha_spaces'"
                      name="name" :readonly="!fieldEnabled" class="input-group" placeholder="Nombre"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                    <p v-show="errors.has('name')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Ingresa un nombre válido
                    </p>
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input id="last_name" type="text" v-model="new_invitation.last_name"
                      v-validate="'required|alpha_spaces'" name="last_name" :readonly="!fieldEnabled"
                      class="input-group" placeholder="Apellido"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                    <p v-show="errors.has('last_name')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Ingresa un apellido válido
                    </p>
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input id="gender" type="text" v-model="new_invitation.gender" v-validate="'required|alpha_spaces'"
                      name="gender" :readonly="!fieldEnabled" class="input-group" placeholder="Género"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                    <p v-show="errors.has('gender')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Ingresa un género válido
                    </p>
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input id="birth_day" type="date" v-model="new_invitation.birth_day" name="birth_day"
                      v-validate="'required'" :readonly="!fieldEnabled" class="input-group"
                      placeholder="Fecha de nacimiento"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                    <p v-show="errors.has('birth_day')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Ingresa una fecha válida
                    </p>
                  </div>

                </div>

                <div
                  style="flex: 1; display: flex; flex-direction: column; justify-content: flex-start; align-items: center;margin-top: 8%">
                  <div
                    style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 15px;"
                    v-bind:style="{
                      display: cameraOpen ? 'flex' : 'none'
                    }">
                    <video ref="video" autoplay muted playsinline
                      style="margin-bottom: 15px; width: 100%; height: 250px; object-fit: cover; border-radius: 8px;"></video>

                    <canvas ref="canvas"
                      style="display: none; margin-bottom: 15px; width: 100%; height: 250px; object-fit: cover; border-radius: 8px;"></canvas>
                  </div>

                  <div
                    style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; margin-top: 15px; background-color: #f0f0f0; border-radius: 8px; overflow: hidden;">
                    <img ref="photo_uploaded" :src="uploadedPhoto"
                      style="display: none; margin-bottom: 15px; width: 100%; height: 250px; object-fit: contain;" />
                  </div>

                  <div ref="button_container"
                    style="display: flex; flex-direction: column; align-items: center; width: 100%; margin-top: 15px;">
                    <!-- Botones en una fila -->
                    <div style="display: flex; justify-content: center; gap: 10px; width: 100%;">
                      <p ref="button_photo" class="invitation__buttons--blue" @click="takePhoto"
                        style="padding: 10px 20px; cursor: pointer; background-color: #007BFF; color: white; border-radius: 5px; display: flex; align-items: center;font-weight: 300;">
                        Tomar Foto
                      </p>

                      <p ref="button_upload" class="invitation__buttons--blue" @click="triggerFileUpload"
                        style="cursor: pointer; padding: 10px 20px; display: flex; align-items: center; text-decoration: underline; color: #7E7E7F;font-weight: 300; ">
                        Cargar Foto
                      </p>
                    </div>

                    <p ref="back_image" class="invitation__buttons--blue" @click="backImage"
                      style="display: none; margin-top: 10px; cursor: pointer;">
                      Regresar
                    </p>

                    <input id="selfie_uploader" type="file" name="user_photo" accept="image/*" style="display:none"
                      @change="uploadGuestImage($event)" />

                    <p ref="retry_button_photo" class="invitation__buttons--blue" @click="retryPhoto"
                      style="display: none; margin-top: 10px; cursor: pointer;">
                      Volver a tomar
                    </p>

                    <p ref="retry_button_load" class="invitation__buttons--blue" @click="retryUpload"
                      style="display: none; margin-top: 10px; cursor: pointer;">
                      Intentar de nuevo
                    </p>

                    <v-dialog v-model="modal_photo_error" persistent max-width="500px">
                      <v-card>
                        <div class="invitation__new">
                          <div class="invitation__new--title">
                            <div class="invitation__new--photo_error">
                              <label class="invitation__new--label">Por favor toma o carga un fotografía.</label>
                            </div>
                          </div>
                          <div class="invitation__new--actions">
                            <v-btn color="info" @click="modal_photo_error = false">OK</v-btn>
                          </div>
                        </div>
                      </v-card>
                    </v-dialog>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="width: 25%;">
            <div class="table_card" style="height: 58vb;">
              <div class="table_card__head"
                style="height: 3.5vb; background-color: #4473C3; display: flex; padding: 0;">
                <p class="table_card__head--title"
                  style="color: #f0f0f0; font-weight: 400; margin: 0 0 0 3%; line-height: 1;">
                  Autoriza
                </p>
              </div>


              <div class="table_card__body" style="padding: 30px 0px;">
                <v-flex xs12 sm12
                  style=" display: flex; flex-direction: column; justify-content: center; align-items: center; height: 300px;">

                  <!-- Contenedor de "Selecciona una locación" -->
                  <div style="margin-bottom: 30%; margin-top: 17%; width: 80%;">

                    <label for="location" style="display: block; margin-bottom: 8px; font-size: 14px; color: #333;">
                      Área
                    </label>
                    <select id="location" v-model="new_invitation.location_id" class="input-group"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; color: #333; background-color: white; appearance: none; -webkit-appearance: none; -moz-appearance: none;"
                      name="location" v-validate="'required'" data-vv-name="location">
                      <option value="" disabled selected style="color: #aaa;">Selecciona una locación</option>
                      <option v-for="location in locations" :key="location.id" :value="location.id"
                        style="padding: 12px; font-size: 14px; color: #333; background-color: white;">
                        {{ location.name }}
                      </option>
                    </select>
                    <p v-show="errors.has('location')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Debes seleccionar una locación
                    </p>
                  </div>

                  <!-- Contenedor de "Persona que autoriza" -->
                  <div style="margin-bottom: 16px; width: 80%;">
                    <label for="authorizing_person"
                      style="display: block; margin-bottom: 8px; font-size: 14px; color: #333;">
                      Persona que autoriza
                    </label>
                    <input id="authorizing_person" type="text" v-model="new_invitation.authorizing_person"
                      v-validate="'required'" name="authorizing_person"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; color: #333;" />
                    <p v-show="errors.has('authorizing_person')" class="invitation__new--error_message"
                      style="color: red; font-size: 12px; margin-top: 4px;">
                      Ingresa una persona que autoriza válida
                    </p>
                  </div>

                </v-flex>
              </div>


            </div>
          </div>

          <div style="width: 25%;">
            <!-- Fecha de Ingreso -->
            <div class="table_card" style="flex: 1; margin-bottom: 5%; height: 28vb">
              <div class="table_card__head"
                style="height: 3.5vb; background-color: #4473C3; display: flex; padding: 0;">
                <p class="table_card__head--title" style="color: #f0f0f0; font-weight: 400; margin: 0 0 0 3%;">
                  Fecha de Ingreso
                </p>
              </div>

              <div class="table_card__body">
                <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">

                  <!-- Contenedor de Fecha y Hora -->
                  <v-flex xs12 sm6 style=" width: 100%;">

                    <!-- Fecha de Ingreso -->
                    <div style="margin-bottom: 16px; width: 200%; box-sizing: border-box;">
                      <label for="entry_date" style="display: block; margin-bottom: 8px; font-size: 14px; color: #333;">
                        Fecha de Ingreso
                      </label>
                      <input id="entry_date" type="date" v-model="new_invitation.entry_date" name="entry_date"
                        :readonly="true" class="input-group"
                        style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;background: #EFEFEF" />
                      <p v-show="errors.has('entry_date')" class="invitation__new--error_message">
                        Ingresa una fecha válida
                      </p>
                    </div>

                    <!-- Hora de ingreso -->
                    <div style="margin-bottom: 16px; width: 200%; box-sizing: border-box;">
                      <label for="entry_time" style="display: block; margin-bottom: 8px; font-size: 14px; color: #333;">
                        Hora de Ingreso
                      </label>
                      <input id="entry_time" type="time" v-model="new_invitation.entry_time" :readonly="true"
                        style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; color: #333;background: #EFEFEF" />
                    </div>

                  </v-flex>

                </div>
              </div>
            </div>

            <!-- Fecha de Salida -->
            <div class="table_card" style="flex: 1;height: 28vb;">
              <div class="table_card__head" :style="{
                backgroundColor: editEnabled ? '#4473C3' : '#7E7E7F',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '3.5vb',
                padding: '0',
                borderRadius: '2px'
              }">
                <p class="table_card__head--title" style="color: #f0f0f0; font-weight: 400; margin: 0 0 0 3%;">Fecha de
                  Salida</p>
                <div style="display: flex; gap: 5px; margin-right: 3%">
                  <button @click="setEditEnabled(true)" :style="activeButtonStyle">On</button>
                  <button @click="setEditEnabled(false)" :style="inactiveButtonStyle">Off</button>
                </div>
              </div>

              <div class="table_card__body" style="overflow: visible; position: relative;">
                <div
                  style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; position: relative;">
                  <!-- Contenedor de Fecha y Hora -->
                  <v-flex xs12 sm6 style=" width: 100%;">
                    <!-- Fecha de Salida -->
                    <div style="margin-bottom: 16px; width: 200%; box-sizing: border-box;">
                      <label for="exit_date" style="display: block; margin-bottom: 8px; font-size: 14px; color: #333;">
                        Fecha de Salida
                      </label>
                      <input id="exit_date" type="date" v-model="new_invitation.exit_date"
                        @focus="isExitDateFocused = true" @blur="isExitDateFocused = false" :disabled="!editEnabled"
                        readonly class="input-group"
                        style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 3px; font-size: 16px; color: #777; box-sizing: border-box;" />
                      <p v-show="errors.has('exit_date')" class="invitation__new--error_message">
                        Ingresa una fecha valida
                      </p>
                    </div>

                    <!-- Hora de Salida -->
                    <div style="margin-bottom: 16px; width: 200%; box-sizing: border-box;">
                      <label for="exit_time" style="display: block; margin-bottom: 8px; font-size: 14px; color: #333;">
                        Hora de Salida
                      </label>
                      <select id="exit_time" v-model="new_invitation.exit_time" :disabled="!editEnabled"
                        class="input-group"
                        style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 3px; font-size: 14px; color: #333;">
                        <option v-for="time in timeOptions" :key="time.value" :value="time.value">
                          {{ time.label }}
                        </option>
                      </select>
                      <p v-show="errors.has('exit_time')" class="invitation__new--error_message">
                        Ingresa una hora válida
                      </p>
                    </div>

                  </v-flex>
                </div>
              </div>
            </div>

            <!-- Time Picker -->
            <div id="floating-time-picker" v-if="editEnabled && (isExitDateFocused || isTimePickerActive)"
              @mouseenter="isTimePickerActive = true" @mouseleave="isTimePickerActive = false"
              style="position: sticky; top: 10%; left: 50%; z-index: 9999; padding: 0; background: none; border: none; box-shadow: none; transform: translateX(-100%) translateY(-35%); width: 80%;">
              <v-date-picker v-model="new_invitation.exit_date" label="Seleccionar hora" color="#007BFF"
                :min="getTodayDate()" @input="updateExitDateTime()" :disabled="!editEnabled"
                style="box-shadow: none; border: 2px solid #7E7E7F; background: none; padding: 0;">
              </v-date-picker>
            </div>





          </div>


        </div>

        <div class="table_card" style="margin-top: 10px; width: 25%;">
          <!-- Cabecera de la tarjeta -->
          <div class="table_card__head" :style="{
            cursor: isCardFilled ? 'not-allowed' : 'pointer',
            backgroundColor: isCardFilled ? '#4473C3' : '#7E7E7F',
            height: '5vb'
          }" @click="!isCardFilled && (isOpen = !isOpen)">
            <p class="table_card__head--title" style="margin: 0; font-size: 16px; font-weight: 400; color: #f0f0f0">
              Datos personales adicionales
            </p>
            <span style="margin-left: auto; display: flex; align-items: center;">
              <img v-if="!isOpen" src="../../../assets/img/sort-down-solid.svg"
                style="width: 20px; height: 20px; transition: transform 0.3s ease;">
              <img v-if="isOpen" src="../../../assets/img/sort-up-solid.svg"
                style="width: 20px; height: 20px; transition: transform 0.3s ease;">
            </span>
          </div>


          <!-- Contenedor del cuerpo (incluso cuando está cerrado) -->
          <div :style="{
            height: isOpen ? 'auto' : '50px',
            overflow: 'hidden',
            padding: isOpen ? '16px' : '8px 16px',
            borderTop: '1px solid #ccc',
            backgroundColor: isOpen ? 'white' : '#f9f9f9',
            transition: 'all 0.3s ease'
          }">
            <div v-if="isOpen" class="table_card__body" style="padding: 0;padding-left: 22px;">
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div style="flex: 1; margin-right: 20px;">
                  <!-- Inputs -->
                  <v-flex style="margin-top: 12px; margin-bottom: 16px;">
                    <select v-model="new_invitation.document_type" class="input-group"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; background-color: white; appearance: none; -webkit-appearance: none; -moz-appearance: none;">
                      <option value="" selected>Tipo de documento</option>
                      <option v-for="document_type in document_types" :key="document_type.id" :value="document_type.id"
                        style="padding: 12px; font-size: 14px; color: #333; background-color: white;">
                        {{ document_type.name }}
                      </option>
                    </select>
                  </v-flex>

                  <div style="margin-bottom: 16px;">
                    <input type="text" placeholder="Número de teléfono" v-model="new_invitation.phone" maxlength="10"
                      name="phone_number"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input type="text" placeholder="Dispositivo (Marca)" v-model="new_invitation.device" name="device"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input type="text" placeholder="Serial" v-model="new_invitation.serial" name="serial"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                  </div>

                  <div style="margin-bottom: 16px;">
                    <input type="text" placeholder="Razón de visita" v-model="new_invitation.reason_visit"
                      name="reason_for_visit"
                      style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 16px; color: #777; box-sizing: border-box;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="invitation__new--actions" style="display: flex; justify-content: space-between;">
          <p class="invitation__buttons--blue" @click="checkHour()"
            style="padding: 10px 80px; cursor: pointer; font-weight: 300; background-color: #76A646; color: white; border-radius: 5px; margin-right: 5%">
            Crear
          </p>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { computed } from 'vue';

export default {
  data() {
    return {
      editEnabled: false,
      isExitDateFocused: false,
      isOpen: false,
      isTimePickerActive: false,
      new_invitation: {
        identification_data: "",
        rut: "",
        name: "",
        last_name: "",
        gender: "",
        birth_day: "",
        invited_photo: null,
        user_id: this.getUserId(),
        document_type: "",
        location_id: null,
        phone: "",
        device: "",
        serial: "",
        reason_visit: "",
        entry_time: "",
        entry_date: null,
        exit_date: null,
        exit_time: null,
        no_exit_date: true,
        country_phone_code: "57",
        end_server: "0",
      },
      fieldEnabled: false,
      cameraOpen: false,
      uploadedPhoto: "",
      modal_photo_error: false,
      modal_hour_error: false,
      document_types: [
        { id: "CD", name: "Carnet Diplomatico" },
        { id: "CC", name: "Cedula de Ciudadania" },
        { id: "CE", name: "Cedula de Extranjeria" },
        { id: "CA", name: "Certificado Cabildo" },
        {
          id: "IS",
          name: "Identificación dada por la Secretaria de Educación"
        },
        { id: "NI", name: "Nit" },
        { id: "PA", name: "Pasaporte" },
        { id: "PE", name: "Permiso Especial de Permanencia" },
        { id: "PPT", name: "Permiso de Protección Temporal" },
        { id: "RC", name: "Registro Civil" },
        { id: "SC", name: "Salvoconducto de Permanencia" },
        { id: "TI", name: "Tarjeta de Identidad" },
        { id: "TM", name: "Tarjeta de Movilidad Fronteriza (tmf)" }
      ],
      locations: null,
      timeOptions: [],
      currentDateTime: new Date().toLocaleString(),
      formattedExitDateTime: "",
    };
  },
  methods: {
    /**
     * Toggles the edit state for exit date and time.
     * @param {boolean} state - Determines whether edit is enabled.
     */
    setEditEnabled(state) {
      if (!state) {
        this.new_invitation.exit_date = this.getTodayDate();
        this.setExitDate();
      }
      this.editEnabled = state;
      this.new_invitation.no_exit_date = !state;
    },

    /**
     * Gets today's date in "YYYY-MM-DD" format.
     * @returns {string} - Today's date.
     */
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    /**
     * Gets the current time in "HH:mm" format.
     * @returns {string} - Current time.
     */
    getHour() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },

    /**
     * Opens the camera and initializes the video stream.
     */
    async openCamera() {
      this.cameraOpen = true;
      const video = this.$refs.video;
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
        });
        video.srcObject = this.stream;
      } catch (error) {
        console.error("Unable to access the camera.", error);
      }
    },

    /**
 * Stops the active camera stream by stopping all associated tracks.
 * Clears the stream object.
 */
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    },

    /**
     * Stops the camera stream and sets the camera state to closed.
     */
    closeCamera() {
      this.stopCamera();
      this.cameraOpen = false;
    },

    /**
     * Reads the provided file (image) as a Base64 URL and assigns it to the guest photo.
     * @param {File} file - The file to be read and loaded as an image.
     */
    loadUserImage(file) {
      const reader = new FileReader();
      reader.onload = () => {

      };
      reader.readAsDataURL(file);
    },

    /**
     * Clears the photo preview on the canvas and resets the UI elements for taking a new photo.
     */
    cancelPhoto() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

      // Clear the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);

      // Reset photo state
      this.photoTaken = false;
      this.photoDataUrl = null;

      // Reset UI visibility
      this.$refs.button_photo.style.display = "block";
      this.$refs.retry_button_photo.style.display = "none";
      canvas.style.display = "none";
      this.$refs.video.style.display = "block";
    },

    /**
     * Revokes the URL of the uploaded photo, clears its data, and shows the selfie section.
     */
    destroyUploadedPhoto() {
      if (this.uploadedPhoto) {
        window.URL.revokeObjectURL(this.uploadedPhoto);
        this.uploadedPhoto = null;
      }

      this.show_selfie_section = true;
      this.show_form_section = false;
    },


    /**
     * Keeps focus on the identification data field if necessary.
     */
    keepFocus() {
      const verification = this.new_invitation.rut === "" && !this.fieldEnabled;
      if (verification) {
        this.$nextTick(() => {
          this.$refs.identificationData.focus();
        });
      }

      return verification;
    },

    /**
     * Populates fields based on the identification data.
     */
    fillFields() {
      const data = this.new_invitation.identification_data.split(",");
      this.new_invitation.rut = String(data[0]);
      this.new_invitation.last_name = `${data[1]} ${data[2]}`;
      this.new_invitation.name = `${data[3]} ${data[4]}`;
      this.new_invitation.gender = data[5];
      this.new_invitation.birth_day = this.formatDate(data[6]);
    },

    /**
     * Formats a date string into "YYYY-MM-DD" format.
     * @param {string} dateStr - Date string to format.
     * @returns {string} - Formatted date.
     */
    formatDate(dateStr) {
      if (dateStr.length === 8) {
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6)}`;
      } else if (dateStr.length === 6) {
        const prefix = parseInt(dateStr.substring(0, 2)) < 50 ? "20" : "19";
        return `${prefix}${dateStr.substring(0, 2)}-${dateStr.substring(2, 4)}-${dateStr.substring(4)}`;
      }
    },

    /**
 * Captures a photo from the video stream, compresses it, and updates the UI.
 */
    takePhoto() {
      const canvas = this.$refs.canvas;
      const video = this.$refs.video;
      const photo = this.$refs.photo_uploaded;
      const takePhotoButton = this.$refs.button_photo;
      const uploadPhotoButton = this.$refs.button_upload;
      const retryTakeButton = this.$refs.retry_button_photo;

      // Set canvas dimensions to match video stream
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Draw video frame to canvas
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert canvas image to Data URL
      const dataUrl = canvas.toDataURL("image/jpeg");

      // Convert Data URL to Blob
      const byteString = atob(dataUrl.split(",")[1]);
      const mimeType = dataUrl.split(",")[0].split(":")[1].split(";")[0];
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: mimeType });

      // Compress image and update state
      this.compressImage(blob, 10).then(compressedBlob => {
        console.log("Compressed image size:", compressedBlob.size);
        this.uploadedPhoto = window.URL.createObjectURL(compressedBlob);
        this.loadUserImage(compressedBlob);
        this.new_invitation.invited_photo = this.uploadedPhoto;
      });

      // Update UI state
      this.photoDataUrl = dataUrl;
      this.photoTaken = true;
      video.style.display = "none";
      takePhotoButton.style.display = "none";
      uploadPhotoButton.style.display = "none";
      retryTakeButton.style.display = "block";
      canvas.style.display = "block";
      photo.style.display = "none";

      this.stopCamera();
    },

    /**
     * Resets the uploaded photo and the camera UI, allowing a new photo to be taken.
     */
    backImage() {
      const uploadPhoto = this.$refs.photo_uploaded;
      const uploadButton = this.$refs.button_upload;
      const backButton = this.$refs.back_image;

      // Hide UI elements
      backButton.style.display = "none";
      uploadPhoto.style.display = "none";

      // Reset photo state and reopen camera
      this.retryPhoto();
      this.destroyUploadedPhoto();
    },

    /**
     * Simulates a click on the file input element for uploading photos.
     */
    triggerFileUpload() {
      document.getElementById("selfie_uploader").click();
    },

    /**
     * Handles the user's image upload, compressing and previewing the selected file.
     * @param {Event} event - The file input event.
     */
    async uploadGuestImage(event) {
      const fileInput = event.target;
      const guestImage = fileInput.files[0];
      if (!guestImage) return;

      // Validate file extension
      const extension = guestImage.type.split("/")[1];
      if (extension !== "jpg" && extension !== "jpeg") {
        alert("Only jpg or jpeg formats are supported.");
        fileInput.value = "";
        return;
      }

      try {
        // Compress the image
        const compressedBlob = await this.compressImage(guestImage, 10);
        this.uploadedPhoto = window.URL.createObjectURL(compressedBlob);
        this.show_selfie_section = false;
        this.show_form_section = true;

        console.log("Compressed image size:", compressedBlob.size);

        // Update UI elements
        const uploadPhoto = this.$refs.photo_uploaded;
        const takePhotoButton = this.$refs.button_photo;
        const uploadPhotoButton = this.$refs.button_upload;
        const backButton = this.$refs.back_image;

        uploadPhotoButton.style.display = "none";
        uploadPhoto.style.display = "block";
        takePhotoButton.style.display = "none";
        backButton.style.display = "block";

        // Preview the photo
        const reader = new FileReader();
        reader.onload = () => {
          this.photoDataUrl = reader.result;
          this.new_invitation.invited_photo = this.photoDataUrl;
        };
        reader.readAsDataURL(compressedBlob);

        this.closeCamera();
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        fileInput.value = "";
      }
    },

    /**
     * Resets the camera and UI state to allow retaking a photo.
     */
    retryPhoto() {
      const takePhotoButton = this.$refs.button_photo;
      const uploadPhotoButton = this.$refs.button_upload;
      const retryTakeButton = this.$refs.retry_button_photo;

      // Reset UI elements
      takePhotoButton.style.display = "block";
      uploadPhotoButton.style.display = "block";
      retryTakeButton.style.display = "none";

      // Reinitialize camera
      this.cancelPhoto();
      this.openCamera();
    },

    /**
     * Clears the uploaded photo and reopens the camera view.
     */
    retryUpload() {
      this.uploadedPhoto = null;
      this.openCamera();
    },

    /**
     * Compresses an image file to reduce its size while maintaining quality.
     * @param {File|Blob} imageFile - The image file to compress.
     * @param {number} quality - The compression quality (0-100).
     * @returns {Promise<Blob>} A promise that resolves to the compressed image blob.
     */
    compressImage(imageFile, quality) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const image = new Image();
        const newWidth = 1000;

        image.onload = () => {
          const aspectRatio = image.height / image.width;
          const newHeight = Math.floor(newWidth * aspectRatio);

          // Set canvas dimensions and draw the image
          canvas.width = newWidth;
          canvas.height = newHeight;
          canvas.getContext("2d").drawImage(image, 0, 0, newWidth, newHeight);

          // Convert the canvas content to a Blob
          canvas.toBlob(
            blob => (blob ? resolve(blob) : reject(new Error("Compression failed"))),
            "image/jpeg",
            quality / 100
          );
        };

        image.src = URL.createObjectURL(imageFile);
      });
    },


    /**
     * Toggles the exit date and time picker based on the no_exit_date flag.
     */
    toggleExitDatePicker() {
      if (this.new_invitation.no_exit_date) {
        this.new_invitation.exit_date = null;
        this.new_invitation.exit_time = null;
      }
    },

    /**
     * Updates the formatted exit date and time string.
     */
    updateExitDateTime() {
      if (this.new_invitation.exit_date && this.new_invitation.exit_time) {
        this.formattedExitDateTime = `${this.new_invitation.exit_date} ${this.new_invitation.exit_time}`;
      }
      this.isTimePickerActive = false;
    },

    /**
     * Hides the time picker and exit date focus.
     * Disables any active states for the time picker or exit date inputs.
    */
    hideTimePicker() {
      this.isExitDateFocused = false;
      this.isTimePickerActive = false;
    },

    /**
     * Formats the date and time inputs into the format: "Fri Dec 06 2024 20:11:00 GMT-0500".
     * Combines the `exit_date` and `exit_time` inputs into a single string with the desired format.
     *
     * @returns {string|null} Formatted date-time string or null if inputs are invalid.
     */
    formatEndServer() {
      const { exit_date, exit_time } = this.new_invitation;
      if (!exit_date || !exit_time) {
        console.error("La fecha o la hora no están definidas");
        return null;
      }

      try {
        const [year, month, day] = exit_date.split("-");
        const [hours, minutes] = exit_time.split(":");

        const localDate = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hours),
          Number(minutes),
          0
        );

        return localDate.toString();
      } catch (error) {
        console.error("Error al formatear la fecha y hora:", error);
        return null;
      }
    },


    /**
     * Validates the exit date and time fields before processing.
     */
    checkHour() {

      if (this.uploadedPhoto) {
        this.createInvitation();
      } else {
        console.log("Foto no cargada (uploadedPhoto es falso).");
        this.modal_photo_error = true;
      }
    },

    /**
     * Creates a new invitation by validating the input, formatting the necessary data, 
     * and sending it as a POST request to the server. The function also handles server 
     * responses and potential errors, updating the application's state and UI accordingly.
    */
    createInvitation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.new_invitation.invited_photo = this.photoDataUrl;
          this.new_invitation.end_server = this.getCurrentTimeInUTC(this.getLocation(this.new_invitation.location_id).time_zone, this.formatEndServer());
          this.new_invitation.country_phonereason_visit_code = this.new_invitation.country_phone_code;
          this.new_invitation.serial = `${this.new_invitation.serial} - Persona que autoriza: ${this.new_invitation.authorizing_person}`;
          console.log(this.new_invitation)
          try {
            this.$http
              .post(
                "invitations/counter_invitation_with_identification",
                {
                  data: this.encrypt(this.new_invitation).toString()
                },
                {
                  headers: {
                    "X-Device-ID": this.getDeviceId(),
                    Authorization: "Bearer " + this.getUserToken()
                  }
                }
              )
              .then(
                function (response) {
                  this.datePickerFirstClick2 = false;
                  this.modal_create = false;
                  this.select = [];
                  this.updateAlertMessage(response.body.message);
                  this.updateIsInAlert(true);
                  this.clearNewInvitationData();
                  if (
                    response.body.meta != undefined &&
                    response.body.meta != null
                  ) {
                    if (
                      response.body.meta.authentication_token != undefined &&
                      response.body.meta.authentication_token != null
                    ) {
                      this.checkToken(response.body.meta.authentication_token);
                    }
                  }
                },
                function (response) {
                  if (typeof response.body.errors[0].details != "object") {
                    this.updateAlertMessage(response.body.errors[0].details);
                    this.updateIsInAlert(true);
                  } else {
                    let message = [];
                    for (var key in response.body.errors[0].details) {
                      message.push(response.body.errors[0].details[key]);
                    }
                    this.updateAlertMessage(message);
                    this.updateIsInAlert(true);
                  }
                }
              );
          } catch (e) {
            alert(e.message);
          }
        }
      });
    },

    /**
     * Clears the form data for creating a new invitation.
     */
    clearNewInvitationData() {
      this.new_invitation = {
        identification_data: "",
        rut: "",
        name: "",
        last_name: "",
        gender: "",
        birth_day: "",
        invited_photo: null,
        user_id: this.getUserId(),
        document_type: "",
        location_id: null,
        phone: "",
        device: "",
        serial: "",
        reason_visit: "",
        entry_date: this.getTodayDate(),
        entry_time: this.getHour(),
        exit_date: this.getTodayDate(),
        no_exit_date: false,
        country_phone_code: "57",
        end_server: "0",
      };
      this.fieldEnabled = false;
      this.cancelPhoto();
      this.closeCamera();
      this.$validator.reset();
      this.destroyUploadedPhoto();
      this.uploadedPhoto = "";
      this.setEditEnabled(false);
      const back_button = this.$refs.back_image;
      back_button.style.display = "none";
      const upload_button = this.$refs.button_upload;
      upload_button.style.display = "block";
      const upload_photo = this.$refs.photo_uploaded;
      upload_photo.style.display = "none";
      this.isOpen = false;
      this.openCamera();
      console.log(this.keepFocus());
    },

    /**
     * Periodically updates the current entry time.
     */
    getCurrentDateTime() {
      setInterval(() => {
        this.new_invitation.entry_time = this.getHour();
      }, 1000);
    },

    /**
     * Fetches locations associated with the user's company.
     */
    getCompanyLocations() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .post(
            "locations/get_all_company_locations",
            { data: this.encrypt(data).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: `Bearer ${this.getUserToken()}`,
              },
            }
          )
          .then((response) => {
            this.locations = response.body.data;
          });
      } catch (error) {
        alert(error);
      }
    },
    /**
      * Generates an array of time options for a 24-hour period in 12-hour format with a given interval.
      * Each time option includes a label (12-hour format with AM/PM) and a value (24-hour format).
      * Populates the `timeOptions` array and calls `setExitDate` to set the default selected time.
      * 
    */
    generateTimeOptions(interval) {
      const times = [];
      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += interval) {
          const hour12 = h % 12 || 12; // Convierte la hora al formato 12 horas
          const ampm = h < 12 ? "AM" : "PM";
          const hour = String(hour12).padStart(2, "0");
          const minute = String(m).padStart(2, "0");
          const label = `${hour}:${minute} ${ampm}`;
          const value = `${String(h).padStart(2, "0")}:${minute}`; // Formato 24h como valor
          times.push({ label, value });
        }
      }
      this.timeOptions = times;

      this.setExitDate();
    },
    /**
      * setExitDate()
      * Sets the default selected time (`new_invitation.exit_time`) to the last available time in the `timeOptions` array.
    */
    setExitDate() {
      if (this.timeOptions.length > 0) {
        this.new_invitation.exit_time = this.timeOptions[this.timeOptions.length - 1].value;
      }
    },

    /** 
     * Capitalizes the first letter of each word in a given string, and converts the rest to lowercase.
    */
    capitalizeFirstLetter(input) {
      return input
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },


    /**
     * Converts a given date string to UTC based on a specified time zone.
     * 
     * @param {string} dateString The date string in the format `YYYY-MM-DDTHH:mm:ss`
     * @param {string} timeZone The time zone to apply (e.g., 'America/New_York')
     * @returns {Date} The converted date in UTC.
     */
    getCurrentTimeInUTC(timeZone, dateString) {
      let date = new Date(dateString);
      date = date.toLocaleString('en-US', { timeZone: timeZone });
      date = new Date(date);
      return date;
    },

    /**
     * Retrieves a location object from the `locations` array based on the given `locationId`.
     * 
     * @param {number|string} locationId - The ID of the location to find.
     * @returns {Object|undefined} The matching location object, or undefined if not found.
    */
    getLocation(locationId) {
      const location = this.locations.find(location => location.id == locationId);
      return location;
    },
  },
  watch: {
    fieldEnabled(newValue) {
      if (!newValue) {
        this.$refs.identificationData.focus();
      }
    },
    isOpen(newValue) {
      if (!this.keepFocus() && newValue) {
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        }, 10);
      }
    },
    'new_invitation.rut'(newVal) {
      this.new_invitation.rut = this.capitalizeFirstLetter(newVal);
    },
    'new_invitation.name'(newVal) {
      this.new_invitation.name = this.capitalizeFirstLetter(newVal);
    },
    'new_invitation.last_name'(newVal) {
      this.new_invitation.last_name = this.capitalizeFirstLetter(newVal);
    },
    'new_invitation.gender'(newVal) {
      this.new_invitation.gender = this.capitalizeFirstLetter(newVal);
    }
  },
  computed: {
    activeButtonStyle() {
      return {
        backgroundColor: this.editEnabled ? "#4770c0" : "#ccc", // Cambia el color según el estado activo
        color: this.editEnabled ? "#fff" : "#666",
        padding: "5px 10px",
        border: "none",
        borderTopLeftRadius: "4px",  // Redondeado
        borderBottomLeftRadius: "4px", // Redondeado
        borderTopRightRadius: "0px", // Recto
        borderBottomRightRadius: "0px", // Recto
        cursor: "pointer",
      };
    },
    inactiveButtonStyle() {
      return {
        backgroundColor: !this.editEnabled ? "#4770c0" : "#ccc", // Cambia el color según el estado activo
        color: !this.editEnabled ? "#fff" : "#666",
        padding: "5px 10px",
        border: "none",
        borderTopRightRadius: "4px", // Redondeado
        borderBottomRightRadius: "4px", // Redondeado
        borderTopLeftRadius: "0px", // Recto
        borderBottomLeftRadius: "0px", // Recto
        cursor: "pointer",
      };
    },
    isCardFilled() {
      return (
        this.new_invitation.document_type ||
        this.new_invitation.phone ||
        this.new_invitation.device ||
        this.new_invitation.serial ||
        this.new_invitation.reason_visit
      );
    }
  },
  mounted() {
    this.openCamera();
    this.getCurrentDateTime();
    this.new_invitation.exit_date = this.getTodayDate();
    this.new_invitation.exit_time = "23:59";
    this.new_invitation.entry_date = this.getTodayDate();
    this.new_invitation.entry_time = this.getHour();
    this.getCompanyLocations();
    this.generateTimeOptions(15);
  },
};
</script>
<style scoped>
.table_card {
  border-radius: 10px
}
</style>


// WEBPACK FOOTER //
// src/components/views/invitations/InvitationCreate.vue